import $ from "jquery";
import { FireComponent } from "@component";

export class CopyWithIcon extends FireComponent {
  constructor(id) {
    super(id);
  }

  initIcon() {
		var lock = this.$component.find('.copy-with-icon__lock');
		var icon = this.$component.find('.icon-target');

		if (lock.length && icon.length) {
			var top = ((lock.offset().top + (lock.height() / 2) - 24) - this.$component.offset().top) - (icon.height() / 2);
		
			icon.css('top', top);
		}
  }

  init() {
    if (!this.componentExists) return;
		this.initIcon();
		
		$(window).on('resize', () => {
			this.initIcon();
		});
  }
}
